import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { FileUploadModule } from 'ng2-file-upload';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { TreeModule } from '@ali-hm/angular-tree-component';

import { NgOpendrawModule } from '@soluzione1/ng-opendraw';
import { ImageCropperComponent } from 'ngx-image-cropper';

import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { JqcloudDirective } from './directives/jqcloud/jqcloud.directive';

import { S1Module } from '@app/s1/s1.module';
import { TimestampToTimePipe } from './pipes/timestamp-to-time.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { InputUserRoleSelectComponent } from './components/input-user-role-select/input-user-role-select.component';
import { InputOptionsSelectComponent } from './components/input-options-select/input-options-select.component';
import { InputSiteSelectComponent } from './components/input-site-select/input-site-select.component';
import { InputRegionSelectComponent } from './components/input-region-select/input-region-select.component';
import { ExtOpenDrawDirective } from './directives/extopendraw/extopendraw.directive';
import { PictureManagementComponent } from './components/picture-management/picture-management.component';
import { InputCodiciModelloSelectComponent } from './components/input-codici-modello-select/input-codici-modello-select.component';
import { InputDescrizioneModelloSelectComponent } from './components/input-descrizione-modello-select/input-descrizione-modello-select.component';
import { InputParteSelectComponent } from './components/input-parte-select/input-parte-select.component';
import { InputEnteCommessaSelectComponent } from './components/input-ente-commessa-select/input-ente-commessa-select.component';
import { InputAnnoCommessaSelectComponent } from './components/input-anno-commessa-select/input-anno-commessa-select.component';
import { InputNumeroCommessaSelectComponent } from './components/input-numero-commessa-select/input-numero-commessa-select.component';
import { InputLuogoSelectComponent } from './components/input-luogo-select/input-luogo-select.component';

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgOpendrawModule,
        ImageCropperComponent,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        TypeaheadModule.forRoot(),
        ToastrModule.forRoot(),
        FileUploadModule,
        TreeModule,
        S1Module,
        RouterModule
    ],
    providers: [
        ColorsService
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        TimestampToTimePipe,
        InputOptionsSelectComponent,
        PictureManagementComponent,
        FileSizePipe,
        InputUserRoleSelectComponent,
        InputRegionSelectComponent,
        InputSiteSelectComponent,
        ExtOpenDrawDirective,
        InputCodiciModelloSelectComponent,
        InputDescrizioneModelloSelectComponent,
        InputParteSelectComponent,
        InputEnteCommessaSelectComponent,
        InputAnnoCommessaSelectComponent,
        InputNumeroCommessaSelectComponent,
        InputLuogoSelectComponent
    ],
    exports: [
        NgOpendrawModule,
        ImageCropperComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        BsDatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        PopoverModule,
        TypeaheadModule,
        ToastrModule,
        FileUploadModule,
        FlotDirective,
        SparklineDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        S1Module,
        InputOptionsSelectComponent,
        PictureManagementComponent,
        InputUserRoleSelectComponent,
        InputRegionSelectComponent,
        InputSiteSelectComponent,
        ExtOpenDrawDirective,
        InputCodiciModelloSelectComponent,
        InputDescrizioneModelloSelectComponent,
        InputParteSelectComponent,
        InputEnteCommessaSelectComponent,
        InputAnnoCommessaSelectComponent,
        InputNumeroCommessaSelectComponent,
        InputLuogoSelectComponent
    ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}
